import { render, staticRenderFns } from "./cogsByProduct.vue?vue&type=template&id=070e4e22&scoped=true"
import script from "./cogsByProduct.vue?vue&type=script&lang=js"
export * from "./cogsByProduct.vue?vue&type=script&lang=js"
import style0 from "./cogsByProduct.vue?vue&type=style&index=0&id=070e4e22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070e4e22",
  null
  
)

export default component.exports